export default __webpack_public_path__ + "static/media/placeholder-champions-logo.79e49597.svg";